const debounceMap = new Map();
export const debounce = (func: Function, timeout = 300, id?: string, clearInit = false) => {
  let timer: any;
  if(clearInit && !timer){
    (...args: any) => {
      func.apply(this, args);
    };
  }
  return (...args: any) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
      if (id) {
        debounceMap.delete(id);
      }
    }, timeout);
  };
};

export function debounceInstace(func: Function, timeout = 300, id?: string) {
  if (!id) {
    return debounce(func, timeout, id);
  }
  if (!debounceMap.has(id)) {
    const debouncedFn = debounce(func, timeout, id);
    debounceMap.set(id, debouncedFn);
  }

  return debounceMap.get(id);
}
